import { render } from "./UpdateProfileInformationForm.vue?vue&type=template&id=26a35338"
import script from "./UpdateProfileInformationForm.vue?vue&type=script&lang=js"
export * from "./UpdateProfileInformationForm.vue?vue&type=script&lang=js"
script.render = render

export default script